export const testimonialContent = {
  heading: "Trusted by the World's Leading Companies",
  subHeading: "Our customers say Excellent",
  testimonialDescription:
    "Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries.",
  clientTesimonailHeading: "Client Testimonials",
};

export const testimonials = [
  // {
  //   name: "Aamanda Hawkins",
  //   company: "JM Test",
  //   designation: "Marketing Consultant",
  //   profileImage: "/images/testimonials/jmtest.avif",
  //   logoImage: "/images/JM_Test_Systems.jpg",
  //   text: "Working with Bitsclan has been absolutely vital to our organizational initiatives for web development, website maintenance, email campaigns, graphic design, & digital marketing projects. Not only do they do great work, but they are extremely responsive, accurate, & have been able to help us meet our needs in any capacity we’ve needed.",
  // },
  // {
  //   name: "Patrick",
  //   company: "Demeterkast",
  //   designation: "CTO",
  //   profileImage: "/images/testimonials/demeterkast.avif",
  //   logoImage: "/images/JM_Test_Systems.jpg",
  //   text: "Working with Bitsclan has been absolutely vital to our organizational initiatives for web development, website maintenance, email campaigns, graphic design, & digital marketing projects. Not only do they do great work, but they are extremely responsive, accurate, & have been able to help us meet our needs in any capacity we’ve needed.",
  // },
  // {
  //   name: "Carl",
  //   company: "Air A2b",
  //   designation: "CTO",
  //   profileImage: "/images/testimonials/aira2b.png",
  //   logoImage: "/images/JM_Test_Systems.jpg",
  //   text: "Working with Bitsclan has been absolutely vital to our organizational initiatives for web development, website maintenance, email campaigns, graphic design, & digital marketing projects. Not only do they do great work, but they are extremely responsive, accurate, & have been able to help us meet our needs in any capacity we’ve needed.",
  // },
  // {
  //   name: "Fred Santiago",
  //   designation: "CTO",
  //   company: "Global Cloud Tech Solutions",
  //   profileImage: "/images/testimonials/Fred-Santiago-bg.avif",
  //   logoImage: "/images/RATECH LOGOBLUE.png",
  //   text: "Thanks to Bitsclan IT Solutions Pvt Ltd's work, three of the end clients have entered into long-term relationships with the client to provide support, so the engagement has been profitable. They're responsive, communicative, & timely, & they're very adaptable to the end client's needs",
  // },
  // {
  //   name: "Johnny",
  //   company: "Song Heart",
  //   designation: "CTO",
  //   profileImage: "/images/testimonials/johnny.avif",
  //   logoImage: "/images/icon-logo.svg",
  //   text: "Working with Bitsclan & their team has been remarkable. Within a short period of time they were able to understand our vision & execute quickly. They are very organized & communicated regularly & clearly. Everyone is complimenting how professional & clean our website is. Nice to wake up & see all the changes made. We are very happy & look forward to continue working with Bitsclan.",
  // },
  // {
  //   name: "Gregor Hakkenberg",
  //   company: "Immogo",
  //   designation: "CTO",
  //   profileImage: "/images/testimonials/Gregor-Hakkenberg-bg.avif",
  //   logoImage: "/images/logo-2.png",
  //   text: "Ridiculously good service! My very old real estate website with obsolete custom software needed some minor repairs. The job seemed straightforward, but was much more complicated than expected. The Bitsclan team dug into the technical problems, kept at it & finally found the solution. Everything works again & I can continue offering service to my clients.",
  // },
  {
    name: "Amanda Hawkins",
    enterprise: "Industrial E-Commerce",
    country: "Louisiana, US",
    countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    designation: "Project Manager at JM Test Systems",
    profileImage: "/images/testimonials/amanda.avif",
    logoImage: "/images/testimonials/logo-jmtest.avif",
    text: "Working with Bitsclan completely modernized our operations. From real-time calibration tracking to automated rentals and reporting, the new e-commerce platform improved efficiency across every department. Their technical expertise and attention to detail made all the difference.",
    serviceTags: [
      { title: "Custom Development", link: "/custom-software-development-services" },
      { title: "ERP Integration", link: "#" },
      { title: "E-Commerce Automation", link: "#" }
    ]
  },
  {
    name: "Ms. Chang Li",
    enterprise: "Fashion & Apparels (E-Commerce)",
    country: "Dubai, UAE",
    countryFlagImage: "/images/testimonials/flags/uae-flag.png",
    designation: "Head of Digital Strategy at Lamise Beauty",
    profileImage: "/images/testimonials/changli.avif",
    logoImage: "/images/testimonials/logo-lamise.png",
    text: "Bitsclan helped us bring the Lamise vision to life a seamless online store that feels elegant yet powerful. Our new Shopify Plus platform integrates with Odoo and marketing automation tools effortlessly, improving both sales and customer engagement.",
    serviceTags: [
      { title: "Shopify Plus", link: "#" },
      { title: "Marketing Automation", link: "#" },
      { title: "Multi-Warehouse Integration", link: "#" }
    ]
  },
  {
    name: "Johnny",
    enterprise: "Entertainment & Music Tech",
    country: "California, US",
    countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    designation: "Founder & CEO at SongHeart",
    profileImage: "/images/testimonials/johnny.avif",
    logoImage: "/images/testimonials/logo-songheart.png",
    text: "Bitsclan took our concept for SongHeart and turned it into a beautiful, intuitive music gifting platform. Their ability to merge creativity with technology allowed us to scale quickly and deliver an unforgettable user experience for our customers.",
    serviceTags: [
      { title: "AI Personalization", link: "/ai-ml-development-services" },
      { title: "Web App Development", link: "/web-app-development-services" },
      { title: "User Experience Design", link: "/custom-software-development-services" }
    ]
  },
  {
    name: "Derek Miles",
    enterprise: "Retail & E-Commerce (Food & Lifestyle)",
    country: "Oregon, US",
    countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    designation: "Operations Director at Abioto Baking",
    profileImage: "/images/testimonials/derek.avif",
    logoImage: "/images/testimonials/logo-abioto.png",
    text: "Bitsclan understood our passion for artisan baking and built a platform that truly reflects it. The new Abioto website combines warmth, functionality, and storytelling helping us reach a wider community of bakers while increasing online conversions.",
    serviceTags: [
      { title: "E-Commerce Design", link: "/ecommerce-services" },
      { title: "Brand Identity", link: "/custom-software-development-services" },
      { title: "Shopify Development", link: "/custom-software-development-services" }
    ]
  },
  {
    name: "Michael Turner",
    enterprise: "Enterprise Automation",
    country: "Austin, US",
    countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    designation: "CTO at BrightPath Logistics",
    profileImage: "/images/testimonials/michael.avif",
    logoImage: "/images/logo-2.png",
    text: "Bitsclan built a chatbot that now handles most of our customer queries. Response times are down to seconds, & our support team is free to focus on complex issues. It’s been a huge boost to efficiency & customer satisfaction.",
    serviceTags: [
      { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
      { title: "AI Automation", link: "/ai-automation-agency" },
      { title: "Generative AI", link: "/generative-ai-development-services" }
    ]
  },
  {
    name: "Sophie Keller",
    enterprise: "Healthcare AI",
    country: "Florida, US",
    countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    designation: "Head of Digital Transformation at Meditech Solutions",
    profileImage: "/images/testimonials/sophie.avif",
    logoImage: "/images/logo-2.png",
    text: "With Bitsclan’s agentic AI, we’ve automated routine admin tasks like scheduling & reporting. Our staff now spends more time with patients, & errors have dropped noticeably. The solution fit right into our workflow.",
    serviceTags: [
      { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
      { title: "AI Automation", link: "/ai-automation-agency" },
      { title: "Generative AI", link: "/generative-ai-development-services" }
    ]
  },
  {
    name: "Sarah Coleman",
    enterprise: "Construction & Industrial Equipment",
    country: "Illinois, US",
    countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    designation: "Training & Product Specialist at American Moisture Test",
    profileImage: "/images/testimonials/sarah.avif",
    logoImage: "/images/testimonials/logo-amt.png",
    text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
    serviceTags: [
      { title: "Custom Web Development", link: "/custom-software-development-services" },
      { title: "Equipment Management System", link: "#" },
      { title: "ERP Integration", link: "#" }
    ]
  },
];
